import { computed, ref } from "vue";
import type { ItemMarkMode } from "../lib/itemMarks";

const STORAGE_KEY = "idle-rpg:item-mark-mode";
const modeRef = ref<ItemMarkMode>("sigil");
let initialized = false;

function readStorage(): ItemMarkMode {
  if (typeof window === "undefined") return "sigil";
  const stored = window.localStorage.getItem(STORAGE_KEY);
  return stored === "shortcode" ? "shortcode" : "sigil";
}

function writeStorage(mode: ItemMarkMode) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(STORAGE_KEY, mode);
}

export function useItemMarkMode() {
  if (!initialized) {
    modeRef.value = readStorage();
    initialized = true;
  }

  const mode = computed({
    get: () => modeRef.value,
    set: (value: ItemMarkMode) => {
      modeRef.value = value;
      writeStorage(value);
    }
  });

  return { mode };
}
